import { mString } from 'lib/helpers/utility';

import Typography from 'components/shared/Typography/Typography';

import { getCostShareLabel } from '../../Letter/lib/helpers';

// `amount` is the full charge the reader is armed with — the due amount, the technology fee and
// the tip — so the headline matches what the card is charged.
const AmountSummaryCard = ({ amount, gratuity = 0, surchargeAmount = 0, costShare }) => {
  const breakdown = getCostShareLabel({
    deductible: costShare?.deductible?.value,
    coPay: costShare?.co_payment?.value,
    coInsurance: costShare?.co_insurance?.value,
    surcharge: surchargeAmount,
    gratuity
  });

  return (
    <div className="flex w-full flex-col items-center gap-3 rounded-lg border border-solid border-primary-200 bg-primary-to-white p-6 text-center">
      <Typography
        variant="p"
        size="medium"
        weight="medium"
        color="primary-500"
        className="!text-sm uppercase !leading-4">
        Your estimated portion today
      </Typography>
      <Typography
        variant="h3"
        weight="semibold"
        color="primary-500"
        className="!text-[44px] !leading-[55px] tracking-[-0.02em]">
        {mString(amount)}
      </Typography>
      {breakdown && (
        <Typography variant="p" size="medium" color="neutral-700" className="!text-sm !leading-4">
          {breakdown}
        </Typography>
      )}
    </div>
  );
};

export default AmountSummaryCard;
